import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Column, DatePicker, RadioButtonWithLabel } from 'seagull';
import { toDateOrNull, toIsoDate } from 'seagull/utils/isoDate';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
import styles from './AiFilterChip.module.scss';
export const RadioChip = (param)=>{
    let { testId, fieldLabel, items, selected, valueLabel, valuePrefix, exactMatch, editable = true, datePicker, tone, onApply, onRemove, biPrefix, autoOpen = false, texts } = param;
    var _ref, _ref1;
    var _items_find;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const [draft, setDraft] = useState(selected);
    const [from, setFrom] = useState(toDateOrNull(datePicker === null || datePicker === void 0 ? void 0 : datePicker.from));
    const [to, setTo] = useState(toDateOrNull(datePicker === null || datePicker === void 0 ? void 0 : datePicker.to));
    const selectedLabel = selected != null ? (_ref = (_items_find = items.find((item)=>item.value === selected)) === null || _items_find === void 0 ? void 0 : _items_find.label) !== null && _ref !== void 0 ? _ref : selected : null;
    const showDatePicker = datePicker != null && draft === datePicker.rangeValue;
    const resetDraft = ()=>{
        setDraft(selected);
        setFrom(toDateOrNull(datePicker === null || datePicker === void 0 ? void 0 : datePicker.from));
        setTo(toDateOrNull(datePicker === null || datePicker === void 0 ? void 0 : datePicker.to));
    };
    const applied = ()=>{
        if (datePicker != null && draft === datePicker.rangeValue) {
            onApply({
                selected: draft,
                from: from != null ? toIsoDate(from) : undefined,
                to: to != null ? toIsoDate(to) : undefined
            });
        } else {
            onApply({
                selected: draft
            });
        }
    };
    return /*#__PURE__*/ _jsxs(AiChipShell, {
        testId: testId,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        operator: exactMatch,
        interactive: exactMatch == null && editable,
        tone: tone,
        valuePrefix: valuePrefix,
        valueLabel: (_ref1 = valueLabel !== null && valueLabel !== void 0 ? valueLabel : selectedLabel) !== null && _ref1 !== void 0 ? _ref1 : texts.all,
        applyText: texts.apply,
        onOpen: resetDraft,
        onApply: applied,
        onRemove: onRemove,
        children: [
            items.map((item)=>/*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                    testId: testIds.AiFilterChipTestIds.Option(item.value),
                    bi: {
                        name: "".concat(biPrefix, "_option")
                    },
                    checked: draft === item.value,
                    onChange: ()=>setDraft(item.value),
                    label: item.label
                }, item.value)),
            showDatePicker && /*#__PURE__*/ _jsxs(Column, {
                gap: 24,
                testId: testIds.AiFilterChipTestIds.DateRange(),
                children: [
                    /*#__PURE__*/ _jsx(DatePicker, {
                        testId: testIds.AiFilterChipTestIds.FromDate(),
                        bi: {
                            name: "".concat(biPrefix, "_from")
                        },
                        label: datePicker.texts.from,
                        value: from,
                        onChange: setFrom,
                        popperClassName: styles.calendarPopper,
                        disableErrors: true
                    }),
                    /*#__PURE__*/ _jsx(DatePicker, {
                        testId: testIds.AiFilterChipTestIds.ToDate(),
                        bi: {
                            name: "".concat(biPrefix, "_to")
                        },
                        label: datePicker.texts.to,
                        value: to,
                        onChange: setTo,
                        popperClassName: styles.calendarPopper,
                        disableErrors: true
                    })
                ]
            })
        ]
    });
};
